'use strict';


    require('../coord/polar/polarCreator');
    require('./angleAxis');
    require('./radiusAxis');
    require('./axisPointer');

    require('./axisPointer/PolarAxisPointer');

    // Polar view
    require('../echarts').extendComponentView({
        type: 'polar'
    });



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/polar.js
// module id = 426
// module chunks = 1